import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    name: 'Kofi Amégassi',
    role: 'Plombier · Smart depuis 2024',
    text: 'Depuis que je suis Smart VADOM, ma clientèle a triplé en 3 mois. L\'application est simple et les paiements sont sécurisés.',
    rating: 5,
  },
  {
    name: 'Afi Fiagbé',
    role: 'Coiffeuse · Smart depuis 2023',
    text: 'VADOM m\'a permis de quitter mon emploi pour me consacrer à ma passion. Aujourd\'hui j\'ai 80+ clients réguliers.',
    rating: 5,
  },
  {
    name: 'Marie T.',
    role: 'Cliente régulière',
    text: 'Service impeccable ! J\'ai trouvé un plombier en moins de 30 minutes. Je recommande vivement.',
    rating: 5,
  },
  {
    name: 'Jean K.',
    role: 'Client depuis 2023',
    text: 'Très pratique pour trouver des artisans de confiance. Le système d\'avis permet de choisir sereinement.',
    rating: 4,
  },
];

const Testimonials = () => {
  return (
    <section className="py-10 bg-[#0a0a0a]">
      <div className="container-custom">
        <h2 className="section-title">
          Ce que disent <span className="text-[#F97316]">nos Smarts</span>
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="card"
            >
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className={`text-lg ${i < testimonial.rating ? 'text-[#F97316]' : 'text-[#333333]'}`}>
                    ★
                  </span>
                ))}
              </div>
              <p className="text-[#AAAAAA] mb-4">"{testimonial.text}"</p>
              <div>
                <p className="font-semibold text-white">{testimonial.name}</p>
                <p className="text-sm text-[#AAAAAA]">{testimonial.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;